const DashboardModule = () => import('@pages/reporting/dashboards/DashboardModule')
const InternalDashboard = () => import('@pages/reporting/dashboards/internal/InternalDashboard')
const AdministratorDashboard = () => import('@pages/reporting/dashboards/administrator/AdministratorDashboard')
export default {
    path: 'dashboard',
    component: DashboardModule,
    children: [
        {
            path: 'internal',
            component: InternalDashboard,
            name: 'internalDashboard',
        },
        {
            path: 'administrator',
            component: AdministratorDashboard,
            name: 'administratorDashboard',
        },
    ],
}
